export const bgClass = backgroundColour =>
  backgroundColour === "grey" ? "bg-grey" : "bg-white"

export const encodeUrl = data =>
  Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
